<script>
export default {
  name: "warehouseAccessUserIcon",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17.1166 20.0167C16.3833 20.2334 15.5166 20.3334 14.5 20.3334H9.49997C8.4833 20.3334 7.61663 20.2334 6.8833 20.0167C7.06663 17.8501 9.29163 16.1417 12 16.1417C14.7083 16.1417 16.9333 17.8501 17.1166 20.0167Z"
      stroke="#7A889B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.5 3.66656H9.50002C5.33335 3.66656 3.66669 5.33323 3.66669 9.4999V14.4999C3.66669 17.6499 4.61669 19.3749 6.88335 20.0166C7.06669 17.8499 9.29169 16.1415 12 16.1415C14.7084 16.1415 16.9334 17.8499 17.1167 20.0166C19.3834 19.3749 20.3334 17.6499 20.3334 14.4999V9.4999C20.3334 5.33323 18.6667 3.66656 14.5 3.66656ZM12 13.8082C10.35 13.8082 9.01669 12.4666 9.01669 10.8166C9.01669 9.16658 10.35 7.83323 12 7.83323C13.65 7.83323 14.9834 9.16658 14.9834 10.8166C14.9834 12.4666 13.65 13.8082 12 13.8082Z"
      stroke="#7A889B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.9833 10.8168C14.9833 12.4668 13.65 13.8084 12 13.8084C10.35 13.8084 9.01666 12.4668 9.01666 10.8168C9.01666 9.16678 10.35 7.83344 12 7.83344C13.65 7.83344 14.9833 9.16678 14.9833 10.8168Z"
      stroke="#7A889B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped></style>
